import { Row } from "@stenajs-webui/core";
import type { FC } from "react";

import { DetailsFieldCell } from "../../../../common-ui/details/DetailsFieldCell";
import {
  MAX_LENGTH_CUSTOMER_REFERENCE,
  MAX_LENGTH_LOADING_NOTE,
} from "../../../../common/fieldLengths";
import type { IntermodalBookingPartnerBookings } from "../../../../common/graphql/fragments/gql/IntermodalBooking";
import { customerReferencePlaceHolder } from "../../../../common/utils/customerUtils";
import { transformCustomer } from "../../../../common/utils/optionTransformers";
import { useAllIntermodalCustomersAsOptions } from "../../../../services/intermodal/hooks/useAllIntermodalCustomersAsOptions";
import { useUpdateIntermodalFieldValue } from "../../../../services/intermodal/hooks/UseUpdateIntermodalFieldValue";
import { ValueTxt } from "../../common/ValueTxt";
import { getOrdinal } from "../../utils/detailsUtils";
import { UpdateIntermodalDropdownField } from "../fields/UpdateIntermodalDropdownField";
import { UpdateIntermodalTextInputField } from "../fields/UpdateIntermodalTextInputField";
import { PartnerBookingStatusTag } from "../PartnerBookingStatusTag";

interface DetailsIntermodalDetailsSectionProps {
  dropOffRef: string | null;
  partnerBookings: IntermodalBookingPartnerBookings;
  pickUpRef: string | null;
}

export const UpdateIntermodalDetailsSection: FC<
  DetailsIntermodalDetailsSectionProps
> = ({ partnerBookings, dropOffRef, pickUpRef }) => {
  const customerOptions = useAllIntermodalCustomersAsOptions();
  const multipleCustomers = customerOptions.length > 1;
  const customer = useUpdateIntermodalFieldValue("customer");

  return (
    <>
      {multipleCustomers && (
        <DetailsFieldCell
          label={"Account"}
          renderField={(id) => (
            <UpdateIntermodalDropdownField
              id={id}
              trackerCategory={"IntermodalUpdate"}
              name={"customer"}
              options={customerOptions}
              transformOption={transformCustomer}
            />
          )}
        />
      )}
      <DetailsFieldCell
        label={"Customer reference"}
        renderField={(id) => (
          <UpdateIntermodalTextInputField
            id={id}
            trackerCategory={"IntermodalUpdate"}
            name={"customerReference"}
            maxLength={MAX_LENGTH_CUSTOMER_REFERENCE}
            placeholder={customerReferencePlaceHolder(customer)}
            showCopyButton
          />
        )}
      />
      {partnerBookings?.map((booking, index) => (
        <DetailsFieldCell
          key={index}
          label={getOrdinal(index + 1) + " train booking"}
          contentRight={
            <Row flex={1} justifyContent={"flex-end"}>
              <PartnerBookingStatusTag partnerBookingStatus={booking.status} />
            </Row>
          }
          renderField={() => <ValueTxt value={booking.number} />}
        />
      ))}
      <DetailsFieldCell
        label={"Drop off reference"}
        renderField={() => <ValueTxt value={dropOffRef} />}
      />
      <DetailsFieldCell
        label={"Pick up reference"}
        renderField={() => <ValueTxt value={pickUpRef} />}
      />
      <DetailsFieldCell
        label={"Loading note"}
        renderField={(id) => (
          <UpdateIntermodalTextInputField
            id={id}
            maxLength={MAX_LENGTH_LOADING_NOTE}
            name={"loadingNote"}
            trackerCategory={"IntermodalUpdate"}
          />
        )}
      />
    </>
  );
};
